import { get } from '../index';

export const getMileStones = (company) => {
  return get(`/milestones/?company=${company}`);
};
